import React from 'react';
import { GiftIcon } from 'lucide-react';
type Bonus = {
  number: string;
  title: string;
  price: string;
  body: string;
  image: string;
  alt: string;
};
const bonuses: Bonus[] = [{
  number: 'Bono 01',
  title: 'Pack de Respuestas Anti-Regateo',
  price: '$19',
  body: 'Para la próxima vez que escuches «está muy caro», «¿me haces descuento?» o «es que otra me cobra menos». Mensajes listos para copiar y pegar que sostienen tu valor sin sonar dura — y sin que termines cediendo otra vez.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/942b1449-9772-49df-ba02-989c898a2e0b.jpg',
  alt: 'Teléfono sobre lino marfil mostrando una conversación de chat, junto a una lapicera dorada'
}, {
  number: 'Bono 02',
  title: 'Guía Express de Primera Respuesta por WhatsApp',
  price: '$17',
  body: 'Qué contestar exactamente al «Hola, ¿precio para boda?». Cómo abrir conversación, detectar presupuesto y llevar a la pareja a una llamada — sin mandar el precio de golpe y sin quedarte esperando.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/ebf39707-3670-449a-81c4-acc418ca3242.jpg',
  alt: 'Mano sosteniendo un teléfono con una conversación de WhatsApp sobre un escritorio marfil'
}, {
  number: 'Bono 03',
  title: 'Mini Guía «Cómo Subir Tus Precios Sin Perder Clientas»',
  price: '$19',
  body: 'Las señales de que ya estás cobrando poco, cómo presentar tus nuevos precios y cómo comunicarlo sin justificarte de más. Para la que sabe que vale más pero le da miedo decirlo en voz alta.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/43e558f1-323e-4573-8b7f-8e2b7a6d4575.jpg',
  alt: 'Hoja de precios marfil con detalles dorados, calculadora y lapicera sobre lino crema'
}, {
  number: 'Bono 04',
  title: 'Checklist de Perfil Premium en Instagram',
  price: '$15',
  body: 'Bio, highlights, post fijado, prueba social y llamados a la acción. Porque tu perfil ya está trabajando: la pregunta es si está trabajando a favor del precio que quieres cobrar.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/7076bbe4-5667-434d-bf87-d4b6c58b30d6.jpg',
  alt: 'Teléfono mostrando una grilla de perfil de redes sociales sobre mármol marfil'
}, {
  number: 'Bono 05',
  title: 'Plantilla de Seguimiento de Leads Nupciales',
  price: '$9',
  body: 'Pareja, fecha, presupuesto estimado, estado del lead y próximo seguimiento. Se acabó perder una boda porque el chat se hundió entre 40 conversaciones.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/d931515f-29e9-4b22-a433-2f4b7ff1dc47.jpg',
  alt: 'Planilla impresa con marcas doradas, lapicera y un reloj pequeño sobre superficie marfil'
}];
export function Bonuses() {
  return <section className="w-full bg-white py-16 sm:py-24" data-id="element-27" data-mp="2a3whurx8siup">
      <div className="mx-auto max-w-6xl px-5" data-id="element-28" data-mp="2f30phe4iq8ix">
        <div className="text-center" data-id="element-29" data-mp="2f1potn6ddgw1">
          <span className="inline-flex items-center gap-2 border border-gold-soft bg-gold-tint px-4 py-2 text-[10px] uppercase tracking-[0.22em] text-ink-soft" data-id="element-30" data-mp="27jrifrjhilx1">
            <GiftIcon className="h-3.5 w-3.5 text-gold-dark" aria-hidden="true" data-id="element-31" data-mp="22lpwmyuoc8hv" />
            5 bonos pro incluidos gratis
          </span>
          <h2 className="mt-8 font-serif text-3xl sm:text-5xl text-ink" data-id="element-32" data-mp="1tkib7hd9b257">
            Valor total: $79 <span className="text-gold-dark" data-id="element-33" data-mp="1ol5iifzpf0up">→ gratis</span> con tu Wedding
            Pro OS
          </h2>
          <div className="rule-gold mx-auto mt-8 w-32" aria-hidden="true" data-id="element-34" data-mp="1jup16ksriv32" />
        </div>

        <ul className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-35" data-mp="1evc7bg3h4nqz">
          {bonuses.map(bonus => <li key={bonus.number} className="flex flex-col overflow-hidden border border-gold-soft/70 bg-ivory" data-id="element-36" data-mp="19wrfa3ydladm">
              <img src={bonus.image} alt={bonus.alt} className="h-44 w-full object-cover" loading="lazy" data-id="element-37" data-mp="15tup9s6iabzn" />
              <div className="flex flex-1 flex-col p-7" data-id="element-38" data-mp="30yccf07nlil9">
                <div className="flex items-center justify-between gap-3" data-id="element-39" data-mp="34zxk875bz6ol">
                  <span className="text-[10px] uppercase tracking-[0.24em] text-gold-dark" data-id="element-40" data-mp="3518pycic6oic">
                    {bonus.number}
                  </span>
                  <span className="inline-flex items-center gap-2 text-xs" data-id="element-41" data-mp="2w5syg2520lfx">
                    <s className="text-ink-muted" data-id="element-42" data-mp="2h9bkr49e6uq7">{bonus.price}</s>
                    <span className="bg-ink px-2.5 py-1 text-[10px] uppercase tracking-[0.16em] text-gold" data-id="element-43" data-mp="2hc66r0820nlq">
                      Gratis
                    </span>
                  </span>
                </div>
                <h3 className="mt-4 font-serif text-xl leading-snug text-ink" data-id="element-44" data-mp="2d889yw67bovu">
                  {bonus.title}
                </h3>
                <p className="mt-4 flex-1 text-[15px] leading-relaxed text-ink-soft" data-id="element-45" data-mp="6itmdnapzjou">
                  {bonus.body}
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}